import React from 'react'
import { createContext } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'

const Context = createContext({})
const initialState = { sitesCollapsed: false }

export function PackagesSitesCollapsedProvider({ children }) {
    const { state, replaceState } = useAppContextState(initialState)
    return <Context.Provider value={{ state, replaceState }}>{children}</Context.Provider>
}

export default Context
